import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-checkout-options',
  templateUrl: './checkout-options.component.html',
  styleUrls: ['./checkout-options.component.css']
})
export class CheckoutOptionsComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  constructor(private activeModal: NgbActiveModal, private router: Router, private toastr: ToastrService) { }

  ngOnInit() {
  }

  signInAccount() {
    this.router.navigateByUrl("/WebPanel/checkout");
    this.decline()
  }
  guestAccount() {
    this.router.navigateByUrl("/WebPanel/guest-checkout");
    this.decline()
  }
  createAccount() {
    localStorage.setItem("isCheckout", "true");
    this.router.navigateByUrl("/WebPanel/account-register");
    this.decline()
  }
  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }


  benefitsOfAccount() {
    this.toastr.info(
      " <br>Access your proofcard images.<br> <br> Add new proofcards to your account.<br> <br>View and edit your orders. <br> <br> Automatically save items to your cart.",
      "Benefits of Account",
      {
        positionClass: "toast-center-center",
        enableHtml: true,
        closeButton: true,
        tapToDismiss: true,
      }
    );
  }

}
